export const ReportingAreaType = "reporting"